import { render, staticRenderFns } from "./customer-box.vue?vue&type=template&id=c0e6587a"
import script from "./customer-box.vue?vue&type=script&lang=js"
export * from "./customer-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports